<template>
    <div class="home fluid-container">
        <background ref="background" :images="background" :doRandom="true"></background>
        <hero></hero>
        <credibility></credibility>
        <customer-care-first></customer-care-first>
        <home-ownership></home-ownership>
        <financial-process></financial-process>
        <customer-feedback></customer-feedback>
        <pulte-cares></pulte-cares>
        <family-of-brands :familyOfBrandLinks="familyOfBrandLinks"></family-of-brands>
    </div>
</template>
<script>
    import {defineAsyncComponent } from 'vue';

    import HomeOwnership from '../components/sections/emotion/HomeOwnership.vue';

    import Credibility from '../components/sections/emotion/Credibility.vue';
    import Hero from '../components/sections/billboard/Hero.vue';

    import highRezImage0 from '../assets/home-hero-image-0.jpg';
    import highRezImage1 from '../assets/home-hero-image-1.jpg';
    import highRezImage2 from '../assets/home-hero-image-2.jpg';
    import highRezImage3 from '../assets/home-hero-image-3.jpg';
    import highRezImage4 from '../assets/home-hero-image-4.jpg';

    import lowRezImage0 from '../assets/home-hero-image-0-thumb.jpg';
    import lowRezImage1 from '../assets/home-hero-image-1-thumb.jpg';
    import lowRezImage2 from '../assets/home-hero-image-2-thumb.jpg';
    import lowRezImage3 from '../assets/home-hero-image-3-thumb.jpg';
    import lowRezImage4 from '../assets/home-hero-image-4-thumb.jpg';

    
    import { mapGetters } from 'vuex';

    export default {
        name: "home",
        components: {            
            'credibility': Credibility,
            'hero': Hero,
            'customer-feedback': defineAsyncComponent(() => import(/* webpackChunkName: "customer-feedback" */ '../components/sections/emotion/Testimonials.vue')),
            'customer-care-first': defineAsyncComponent(() => import(/* webpackChunkName: "customer-care-first" */ '../components/sections/emotion/CustomerCareFirst.vue')),
            'pulte-cares': defineAsyncComponent(() => import(/* webpackChunkName: "pulteCares" */ '../components/sections/emotion/PulteCares.vue')),
            'financial-process': defineAsyncComponent(() => import(/* webpackChunkName: "financialProcess" */ '../components/sections/help/OurFinancialProcess.vue')),
            'home-ownership': HomeOwnership
        },
        data() {
            return {
                highRezBackgrounds: [
                { img: highRezImage0, name: 'home-hero-image-0' },
                { img: highRezImage1, name: 'home-hero-image-1' },
                { img: highRezImage2, name: 'home-hero-image-2' },
                { img: highRezImage3, name: 'home-hero-image-3' },
                { img: highRezImage4, name: 'home-hero-image-4' }
            ],
            lowRezBackgrounds: [
                { img: lowRezImage0, name: 'home-hero-image-0' },
                { img: lowRezImage1, name: 'home-hero-image-1' },
                { img: lowRezImage2, name: 'home-hero-image-2' },
                { img: lowRezImage3, name: 'home-hero-image-3' },
                { img: lowRezImage4, name: 'home-hero-image-4' }
            ],
                isMounted: false
            };
        },
        computed:{
            ...mapGetters(['familyOfBrandLinks']),
            background() {
                if (this.isMounted) {
                    return this.highRezBackgrounds;
                }
                return this.lowRezBackgrounds;
            }
        },
        mounted() {
            this.isMounted = true;
            this.$nextTick(() => this.$refs.background.updateBG(true));
        }
    
    }
</script>
<style lang="scss">

    .pmc {

    .pmc-logo {
        cursor: pointer;
    }

    .home {
        #overlay
        {
            position: fixed; /* Sit on top of the page content */
            display: none; /* Hidden by default */
            width: 100%; /* Full width (cover the whole page) */
            height: 100%; /* Full height (cover the whole page) */
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.25); /* Black background with opacity */
            z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
            cursor: pointer; /* Add a pointer on hover */
        }
    .bg {
        background-position: center center !important;
        height: 785px;
        background: rgb(255, 255, 255);
        transition: background 0.5s linear;
        -webkit-transition: background 1.5s linear;
        height: 100%;
        width: 100%;
    }
    @media (max-width:1400px) {
        .bg {
            background-position: top !important;
            height: 670px;
        }
    }
    @media (max-width: 1025px) {
        .bg {
            background-position: top !important;
            height: 700px;
        }
    }
        @media (max-width:992px) {
            .bg {
                background-position: top !important;
                height: 600px;
            }
        }

        @media (max-width:767px) {
            .bg {
                background-position: top !important;
                height: 500px;
            }
        }

        @media (max-width:420px) {
            .bg {
                background-position: top center !important;
                height: 660px;
            }
            div#home-hero-image-0 {
                background-position: 64% center!important;
            }
            div#home-hero-image-3 {
                background-position: -500px top !important;
            }
        }

        @media (max-width:375px) {
            .bg {
                background-position: top center !important;
                height: 510px;
            }
        }

        @media (max-height:420px) and (max-width:767px) {
            .bg {
                background-position: top !important;
                height: 350px;
            }
        }
    }
    }
</style>
